import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useAtom } from "jotai";
import { baseAtom, setOrgToggle } from "../../stores/jotai/base";

export default function MaterialOrgTreeToggle(props) {
  const { disabled, tooltipText } = props;
  const [base, setBase] = useAtom(baseAtom);
  let orgTreeOpen = base?.app?.orgTreeOpen;

  let iconButtonStyle = {};

  if (props.iconButtonStyle !== undefined) {
    iconButtonStyle = { ...props?.iconButtonStyle };
  }

  let menuIconButtonStyle = { color: "white" };

  if (props.menuIconButtonStyle !== undefined) {
    menuIconButtonStyle = { ...props?.menuIconButtonStyle };
  }

  const renderTooltipText = () => {
    if (!!tooltipText) {
      return tooltipText;
    }

    return orgTreeOpen ? "Hide Cohort Teams" : "Show Cohort Teams";
  };

  return (
    <Tooltip title={renderTooltipText()}>
      <Box component="span" ml={1}>
        <IconButton
          id="joy-app-orgtree-toggle"
          onClick={() => {
            setOrgToggle(setBase, !orgTreeOpen);
          }}
          sx={iconButtonStyle}
          disabled={disabled}
        >
          <MenuOpenIcon sx={menuIconButtonStyle} />
        </IconButton>
      </Box>
    </Tooltip>
  );
}
